import { Box, Typography } from "@mui/material";

export const getProfitCalcColumns = () => [
  {
    id: "serial",
    header: () => <div>S/N</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.index + 1}</Typography>
    ),
  },
  {
    accessorKey: "product",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Chargeable Product</div>
    ),
    cell: ({ row }) => (
      <Box>
        <Typography fontSize="0.85rem" fontWeight={500}>
          {row.original.product?.name ?? "—"}
        </Typography>
        <Typography fontSize="0.75rem" color="text.secondary">
          {row.original.product?.code ?? ""}
        </Typography>
      </Box>
    ),
  },
  {
    accessorKey: "category",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Category</div>,
    cell: ({ row }) => (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.5,
          borderRadius: "999px",
          backgroundColor: "#eff6ff",
          color: "#1d4ed8",
          fontSize: "0.8rem",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: "#2563eb",
          }}
        />
        {row.original.category?.name ?? "—"}
      </Box>
    ),
  },
  {
    accessorKey: "feeChargedToCustomer",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Fee Charged - WAYA</div>
    ),
    cell: ({ row }) => {
      const val = row.original.feeChargedToCustomer;
      return (
        <Typography fontSize="0.85rem" color="success.main" fontWeight={500}>
          {val != null ? `${val.toFixed(2)}%` : "—"}
        </Typography>
      );
    },
  },
  {
    accessorKey: "feePayTo3rdParty",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Fee Paid - 3RD PARTY</div>
    ),
    cell: ({ row }) => {
      const val = row.original.feePayTo3rdParty;
      return (
        <Typography fontSize="0.85rem" color="error.main" fontWeight={500}>
          {val != null ? `${val.toFixed(2)}%` : "—"}
        </Typography>
      );
    },
  },
  {
    accessorKey: "profit",
    header: () => (
      <div style={{ whiteSpace: "nowrap" }}>Profit (WAYA - 3RD PARTY)</div>
    ),
    cell: ({ row }) => {
      const val = row.original.profit;
      return (
        <Typography fontSize="0.85rem" fontWeight={600} color="primary.main">
          {val != null ? `${val.toFixed(2)}%` : "—"}
        </Typography>
      );
    },
  },
];
